/**
 * `/raporty/nowa` — the survey editor, on a check-in that does not exist on the server yet.
 *
 * A path and a screen, exactly like its numeric sibling. A STATIC segment, so TanStack Router ranks
 * it above `/raporty/$templateId` and no magic string has to live inside a path parameter —
 * `/plans/nowy` takes the same shape for the same reason.
 *
 * **No loader and no read of a template.** There is nothing on the server to fetch until the
 * trainer's first „Zapisz zmiany", which POSTs the form and replaces this address with
 * `/raporty/<newId>`. The standard catalog IS read, because a new check-in is composed from it.
 *
 * `?klient=<id>` (8 October 2026): the editor was opened from that client's card, and its first
 * save assigns the new check-in to them and returns to their Ankiety tab. The rule is the slice's
 * (`model/newSurveySearch`).
 */

import { createFileRoute } from '@tanstack/react-router';

import { SurveyEditorScreen, validateNewSurveySearch } from '~/pages/reports';

export const Route = createFileRoute('/_shell/raporty/nowa')({
  validateSearch: validateNewSurveySearch,
  component: NewSurveyRoute,
});

function NewSurveyRoute() {
  const { klient } = Route.useSearch();
  return <SurveyEditorScreen target={{ kind: 'new', forClientId: klient ?? null }} />;
}
